module.exports = __webpack_public_path__ + "img/scratching-sm.12f045b2.png";